import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface } from '@sport-activities/sdk';

import { FormGroupValueInterface } from '~/component/form/interfaces/form-group-value.interface';
import { FormControlService } from '~/core/services/form/form-control.service';
import { RoutingInterface } from '~/core/services/navigation/interfaces/routing.interface';
import { NavigationService } from '~/core/services/navigation/navigation.service';
import { TitleService } from '~/core/services/title/title.service';
import { AbstractOrganizerActivityCreationFormPageDirective } from '~/organizer/activity-creation/components/shared/form-wrapper/classes/abstract-activity-creation-form-page';
import { NAVIGATION_ROUTING } from '~/organizer/shared/components/shared/navigation-buttons/navigation-buttons.component';
import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';
import { OrganizerSharedOrganizationService } from '~/organizer/shared/services/organization/organization.service';
import { ToggleService } from '~/toggles/services/toggle.service';

import { TypeConfigInterface } from './interfaces/type.config.interface';
import { TypeInterface } from './interfaces/type.interface';
import { ActivityCreationTypes } from './type';

@Component({
  selector: 'app-organizer-activity-creation-type',
  templateUrl: './type.component.html',
  styleUrls: [
    '../../../../../organizer/shared/components/shared/form-wrapper/form-wrapper.component.scss',
  ],
})
export class OrganizerActivityCreationPageTypeComponent extends AbstractOrganizerActivityCreationFormPageDirective {
  protected readonly pageTitleKey =
    'seo.organizer.activity_creation.type.title';
  public displayValidationError = false;

  public types: TypeInterface[] = [];
  public typesConfig: TypeConfigInterface[] = [];

  constructor(
    private readonly translateService: TranslateService,
    protected readonly activatedRoute: ActivatedRoute,
    protected readonly activityService: OrganizerSharedActivityService,
    protected readonly formBuilder: FormBuilder,
    protected readonly navigationService: NavigationService,
    protected readonly organizationService: OrganizerSharedOrganizationService,
    @Inject(NAVIGATION_ROUTING)
    protected readonly navigationRouting: RoutingInterface[],
    protected readonly titleService: TitleService,
    private readonly toggleService: ToggleService,
    private readonly formControlService: FormControlService
  ) {
    super(
      activatedRoute,
      activityService,
      formBuilder,
      navigationService,
      organizationService,
      navigationRouting,
      titleService
    );
  }

  private buildTypes(): void {
    this.types = this.typesConfig.map((config) => ({
      label: this.translateService.instant(config.labelKey),
      htmlValue: config.htmlValue,
    }));
  }

  protected buildDataBeforeSubmit(
    formGroupValue: FormGroupValueInterface
  ): Partial<ActivityInterface> {
    return {
      type: formGroupValue.type,
    };
  }

  protected buildValidationConfig(): void {
    this.validationConfig = {
      type: [this.activityService.activity?.type || '', Validators.required],
    };
  }

  protected onInitHook(): void {
    Object.keys(ActivityCreationTypes).forEach((key) => {
      if (this.toggleService.isEnabled(key)) {
        this.typesConfig.push(ActivityCreationTypes[key]);
      }
    });

    this.buildTypes();
  }

  public errorMessages(inputName: string): string[] {
    const control = this.formGroup.get(inputName);
    return (
      this.displayValidationError &&
      this.formControlService.getErrorMessages(control, inputName)
    );
  }

  public submit(formGroupValue: FormGroupValueInterface): void {
    if (this.formGroup.invalid) {
      this.displayValidationError = true;
      return;
    }

    super.submit(formGroupValue);
  }
}
